export enum CompanyAcronymsEnum {
  'AAFY' = 'AAFY',
  'ADOS' = 'ADOS',
  'ANNA' = 'ANNA',
  'ANS' = 'ANS',
  'AS' = 'AS',
  'ASA' = 'ASA',
  'BA' = 'BA',
  'BBL' = 'BBL',
  'BEDR' = 'BEDR',
  'BO' = 'BO',
  'BRL' = 'BRL',
  'DA' = 'DA',
  'ENK' = 'ENK',
  'EØFG' = 'EØFG',
  'ESEK' = 'ESEK',
  'FKF' = 'FKF',
  'FLI' = 'FLI',
  'NIF' = 'NIF',
  'FYLK' = 'FYLK',
  'GFS' = 'GFS',
  'IKJP' = 'IKJP',
  'IKS' = 'IKS',
  'IKSR' = 'IKSR',
  'SBSTI' = 'SBSTI',
  'KBO' = 'KBO',
  'KF' = 'KF',
  'KIRK' = 'KIRK',
  'KOMM' = 'KOMM',
  'KS' = 'KS',
  'KTRF' = 'KTRF',
  'NUF' = 'NUF',
  'OPMV' = 'OPMV',
  'ORGL' = 'ORGL',
  'PERS' = 'PERS',
  'PK' = 'PK',
  'PRE' = 'PRE',
  'SA' = 'SA',
  'SAM' = 'SAM',
  'SE' = 'SE',
  'SF' = 'SF',
  'SPA' = 'SPA',
  'STI' = 'STI',
  'STAT' = 'STAT',
  'SÆR' = 'SÆR',
  'TVAM' = 'TVAM',
  'VPFO' = 'VPFO',
  'UTLA' = 'UTLA',
  'SUBGR' = 'SUBGR',
  'SUBGR-GENERAL' = 'SUBGR-GENERAL',
  'SUBGR-STYR' = 'SUBGR-STYR',
  'SUBGR-LEDER' = 'SUBGR-LEDER',
  'SUBGR-VALGKOMITE' = 'SUBGR-VALGKOMITE',
  'SUBGR-RENUM' = 'SUBGR-RENUM',
  'SUBGR-KONTROL' = 'SUBGR-KONTROL',
  'SUBGR-REVISJON' = 'SUBGR-REVISJON',
  'SUBGR-PROJECT' = 'SUBGR-PROJECT',
  'SUBGR-DD' = 'SUBGR-DD',
  'SUBGR-WORKGROUP' = 'SUBGR-WORKGROUP',
  'SUBGR-COMMITTEE_ENV' = 'SUBGR-COMMITTEE_ENV',
}

// These are used for the organizational differences in terminology
export enum CompanyTerminologyEnum {
  'default' = 'default',
  'fliAlike' = 'fliAlike',
  'BRL' = 'BRL',
  'ESEK' = 'ESEK',
  'AS' = 'AS',
  'SUBGR-DD' = 'SUBGR-DD',
  'SUBGR' = 'SUBGR',
  'SAM' = 'SAM',
}

export type CompanyAcronymsMap = {
  [type in CompanyAcronymsEnum]: {
    nb: string;
    en: string;
    sv?: string;
    terminolgy?: CompanyTerminologyEnum;
    hubspot?: HubspotGroups;
  };
};

export enum HubspotGroups {
  LimitedCompany = 'Limited company',
  PublicLimitedCompany = 'Public limited company',
  Foundation = 'Foundation',
  AssociationClubOrganisation = 'Association/club/organisation',
  CoOperative = 'Co-operative',
  HousingCooperative = 'Housing cooperative',
  JointOwnership = 'Joint ownership',
  InterMunicipalCompany = 'Inter Municipal Company',
  MunicipalBusinessEnterprise = 'Municipal Business Enterprise',
  Other = 'Other',
  Subentityfornontraders = 'Sub-entity for non-traders',
  AdministrativeentityPublicsector = 'Administrative entity - Public sector',
  Otherbodycorporate = 'Other body corporate',
  GeneralPartnership = 'General Partnership',
  Companywithlimitedliability = 'Company with limited liability',
  Housebuildingcooperative = 'House building cooperative',
  Subentityforbusinessesandpublicmanagement = 'Sub-entity for businesses and public management',
  Otherestates = 'Other estates',
  GeneralPartnershipwithsharedliability = 'General Partnership with shared liability',
  Soleproprietorship = 'Sole proprietorship',
  EuropeanEconomicEnterpriseGroup = 'European Economic Enterprise Group',
  Condominiumflatowner = 'Condominium flat owner',
  Countymunicipalbusinessenterprise = 'County municipal business enterprise',
  Countymunicipality = 'County municipality',
  Mutualinsurancecompany = 'Mutual insurance company',
  Othernonbodycorporate = 'Other non-body corporate',
  Bankruptestate = 'Bankrupt estate',
  Councilofchurches = 'Council of churches',
  Municipality = 'Municipality',
  Limitedpartnership = 'Limited partnership',
  Jointoffice = 'Joint office',
  Norwegiandivisionofforeignbusinessenterprise = 'Norwegian division of foreign business enterprise',
  Speciallysectionedunit = 'Specially sectioned unit, cf. VAT Act, Section 2-2.',
  Organisationalsection = 'Organisational section',
  Otherindividualsregisteredinaffiliatedregister = 'Other individuals registered in affiliated register',
  Pensionfund = 'Pension fund',
  Jointlyownedshippingcompany = 'Jointly owned shipping company',
  Europeancompany = 'European company',
  Publiccorporation = 'Public corporation',
  Savingsbank = 'Savings bank',
  State = 'State',
  Otherbusinessenterpriseinaccordancewithspeciallegislation = 'Other business enterprise in accordance with special legislation',
  CompulsoryregistrationintheValueAddedTaxRegister = 'Compulsory registration in the Value Added Tax Register',
  Foreignentity = 'Foreign entity',
  Unittrusts = 'Unit trusts',
  NIF = 'NIF',
}

export const companyAcronymsMap: CompanyAcronymsMap = {
  [CompanyAcronymsEnum.AAFY]: {
    nb: 'Ikke næringsdrivende virksomhet',
    en: 'No business activity',
    hubspot: HubspotGroups.Subentityfornontraders,
  },
  [CompanyAcronymsEnum.ADOS]: {
    nb: 'Administrativ enhet - offentlig sektor',
    en: 'Administrative entity - Public sector',
    hubspot: HubspotGroups.AdministrativeentityPublicsector,
  },
  [CompanyAcronymsEnum.ANNA]: {
    nb: 'Annen juridisk person',
    en: 'Other body corporate',
    hubspot: HubspotGroups.Otherbodycorporate,
  },
  [CompanyAcronymsEnum.ANS]: {
    nb: 'Ansvarlig selskap med solidarisk ansvar',
    en: 'General Partnership',
    terminolgy: CompanyTerminologyEnum.fliAlike,
    hubspot: HubspotGroups.GeneralPartnership,
  },
  [CompanyAcronymsEnum.AS]: {
    nb: 'Aksjeselskap',
    en: 'Limited company',
    terminolgy: CompanyTerminologyEnum.AS,
    hubspot: HubspotGroups.LimitedCompany,
  },
  [CompanyAcronymsEnum.ASA]: {
    nb: 'Allmennaksjeselskap',
    en: 'Public limited company',
    hubspot: HubspotGroups.PublicLimitedCompany,
  },
  [CompanyAcronymsEnum.BA]: {
    nb: 'Selskap med begrenset ansvar',
    en: 'Company with limited liability',
    terminolgy: CompanyTerminologyEnum.fliAlike,
    hubspot: HubspotGroups.Companywithlimitedliability,
  },
  [CompanyAcronymsEnum.BBL]: {
    nb: 'Boligbyggelag',
    en: 'House building cooperative',
    hubspot: HubspotGroups.Housebuildingcooperative,
  },
  [CompanyAcronymsEnum.BEDR]: {
    nb: 'Bedrift',
    en: 'Enterprise',
    hubspot: HubspotGroups.Subentityforbusinessesandpublicmanagement,
  },
  [CompanyAcronymsEnum.BO]: {
    nb: 'Andre bo',
    en: 'Other estates',
    hubspot: HubspotGroups.Otherestates,
  },
  [CompanyAcronymsEnum.BRL]: {
    nb: 'Borettslag',
    en: 'Housing cooperative',
    terminolgy: CompanyTerminologyEnum.BRL,
    hubspot: HubspotGroups.HousingCooperative,
  },
  [CompanyAcronymsEnum.DA]: {
    nb: 'Ansvarlig selskap med delt ansvar',
    en: 'General Partnership with shared liability',
    terminolgy: CompanyTerminologyEnum.fliAlike,
    hubspot: HubspotGroups.GeneralPartnershipwithsharedliability,
  },
  [CompanyAcronymsEnum.ENK]: {
    nb: 'Enkeltpersonforetak',
    en: 'Sole proprietorship',
    hubspot: HubspotGroups.Soleproprietorship,
  },
  [CompanyAcronymsEnum.EØFG]: {
    nb: 'Europeisk økonomisk foretaksgruppe',
    en: 'European Economic Enterprise Group',
    hubspot: HubspotGroups.EuropeanEconomicEnterpriseGroup,
  },
  [CompanyAcronymsEnum.ESEK]: {
    nb: 'Eierseksjonssameie',
    en: 'Condominium flat owner',
    terminolgy: CompanyTerminologyEnum.ESEK,
    hubspot: HubspotGroups.Condominiumflatowner,
  },
  [CompanyAcronymsEnum.FKF]: {
    nb: 'Fylkeskommunalt foretak',
    en: 'County municipal business enterprise',
    terminolgy: CompanyTerminologyEnum.fliAlike,
    hubspot: HubspotGroups.Countymunicipalbusinessenterprise,
  },
  [CompanyAcronymsEnum.FLI]: {
    nb: 'Forening/lag/innretning',
    en: 'Association/club/organization',
    terminolgy: CompanyTerminologyEnum.fliAlike,
    hubspot: HubspotGroups.AssociationClubOrganisation,
  },
  [CompanyAcronymsEnum.NIF]: {
    nb: 'Forening/lag/innretning',
    en: 'Association/club/organization',
    terminolgy: CompanyTerminologyEnum.fliAlike,
    hubspot: HubspotGroups.NIF,
  },
  [CompanyAcronymsEnum.FYLK]: {
    nb: 'Fylkeskommune',
    en: 'County municipality',
    hubspot: HubspotGroups.Countymunicipality,
  },
  [CompanyAcronymsEnum.GFS]: {
    nb: 'Gjensidig forsikringsselskap',
    en: 'Mutual insurance company',
    hubspot: HubspotGroups.Mutualinsurancecompany,
  },
  [CompanyAcronymsEnum.IKJP]: {
    nb: 'Andre ikke-juridiske personer',
    en: 'Other non-body corporate',
    hubspot: HubspotGroups.Othernonbodycorporate,
  },
  [CompanyAcronymsEnum.IKS]: {
    nb: 'Interkommunalt selskap',
    en: 'Inter-municipal company',
    terminolgy: CompanyTerminologyEnum.fliAlike,
    hubspot: HubspotGroups.InterMunicipalCompany,
  },
  [CompanyAcronymsEnum.IKSR]: {
    nb: 'Interkommunalt selskap Representant',
    en: 'Inter-municipal company Representative',
    terminolgy: CompanyTerminologyEnum.fliAlike,
    hubspot: HubspotGroups.InterMunicipalCompany,
  },
  [CompanyAcronymsEnum.SBSTI]: {
    nb: 'Stiftelse',
    en: 'Foundation',
    terminolgy: CompanyTerminologyEnum.fliAlike,
    hubspot: HubspotGroups.Foundation,
  },
  [CompanyAcronymsEnum.KBO]: {
    nb: 'Konkursbo',
    en: 'Bankrupt estate',
    hubspot: HubspotGroups.Bankruptestate,
  },
  [CompanyAcronymsEnum.KF]: {
    nb: 'Kommunalt foretak',
    en: 'Municipal business enterprise',
    terminolgy: CompanyTerminologyEnum.fliAlike,
    hubspot: HubspotGroups.MunicipalBusinessEnterprise,
  },
  [CompanyAcronymsEnum.KIRK]: {
    nb: 'Den norske kirke',
    en: 'The Church of Norway',
    hubspot: HubspotGroups.Councilofchurches,
  },
  [CompanyAcronymsEnum.KOMM]: {
    nb: 'Kommune',
    en: 'Municipality',
    hubspot: HubspotGroups.Municipality,
  },
  [CompanyAcronymsEnum.KS]: {
    nb: 'Kommandittselskap',
    en: 'Limited partnership',
    hubspot: HubspotGroups.Limitedpartnership,
  },
  [CompanyAcronymsEnum.KTRF]: {
    nb: 'Kontorfellesskap',
    en: 'Joint office',
    hubspot: HubspotGroups.Jointoffice,
  },
  [CompanyAcronymsEnum.NUF]: {
    nb: 'Norskregistrert utenlandsk foretak',
    en: 'Norwegian registered foreign business',
    hubspot: HubspotGroups.Norwegiandivisionofforeignbusinessenterprise,
  },
  [CompanyAcronymsEnum.OPMV]: {
    nb: 'Særskilt oppdelt enhet, jf. mval. § 2-2',
    en: 'Specially sectioned unit',
    hubspot: HubspotGroups.Speciallysectionedunit,
  },
  [CompanyAcronymsEnum.ORGL]: {
    nb: 'Organisasjonsledd',
    en: 'Organizational section',
    hubspot: HubspotGroups.Organisationalsection,
  },
  [CompanyAcronymsEnum.PERS]: {
    nb: 'Andre enkeltpersoner som registreres i tilknyttet register',
    en: 'Other individuals registered in affiliated register',
    hubspot: HubspotGroups.Otherindividualsregisteredinaffiliatedregister,
  },
  [CompanyAcronymsEnum.PK]: {
    nb: 'Pensjonskasse',
    en: 'Pension fund',
    hubspot: HubspotGroups.Pensionfund,
  },
  [CompanyAcronymsEnum.PRE]: {
    nb: 'Partrederi',
    en: 'Jointly owned shipping company',
    hubspot: HubspotGroups.Jointlyownedshippingcompany,
  },
  [CompanyAcronymsEnum.SA]: {
    nb: 'Samvirkeforetak',
    en: 'Co-operative',
    terminolgy: CompanyTerminologyEnum.fliAlike,
    hubspot: HubspotGroups.CoOperative,
  },
  [CompanyAcronymsEnum.SAM]: {
    nb: 'Tingsrettslig sameie',
    en: 'Joint ownership according to the law of property',
    terminolgy: CompanyTerminologyEnum.SAM,
    hubspot: HubspotGroups.JointOwnership,
  },
  [CompanyAcronymsEnum.SE]: {
    nb: 'Europeisk selskap',
    en: 'European company',
    hubspot: HubspotGroups.Europeancompany,
  },
  [CompanyAcronymsEnum.SF]: {
    nb: 'Statsforetak',
    en: 'Public corporation',
    hubspot: HubspotGroups.Publiccorporation,
  },
  [CompanyAcronymsEnum.SPA]: {
    nb: 'Sparebank',
    en: 'Savings bank',
    hubspot: HubspotGroups.Savingsbank,
  },
  [CompanyAcronymsEnum.STI]: {
    nb: 'Stiftelse',
    en: 'Foundation',
    terminolgy: CompanyTerminologyEnum.fliAlike,
    hubspot: HubspotGroups.Foundation,
  },
  [CompanyAcronymsEnum.STAT]: {
    nb: 'Staten',
    en: 'State',
    hubspot: HubspotGroups.State,
  },
  [CompanyAcronymsEnum.SÆR]: {
    nb: 'Annet foretak ifølge særskilt lov',
    en: 'Other business enterprise in accordance with special legislation',
    hubspot: HubspotGroups.Otherbusinessenterpriseinaccordancewithspeciallegislation,
  },
  [CompanyAcronymsEnum.TVAM]: {
    nb: 'Tvangsregistrert for MVA',
    en: 'Compulsory registration in the Value Added Tax Register',
    hubspot: HubspotGroups.CompulsoryregistrationintheValueAddedTaxRegister,
  },
  [CompanyAcronymsEnum.VPFO]: {
    nb: 'Verdipapirfond',
    en: 'Unit trusts',
    hubspot: HubspotGroups.Unittrusts,
  },
  [CompanyAcronymsEnum.UTLA]: {
    nb: 'Utenlandsk enhet',
    en: 'Foreign entity',
    hubspot: HubspotGroups.Foreignentity,
  },
  [CompanyAcronymsEnum['SUBGR-GENERAL']]: {
    nb: 'Generell gruppe',
    en: 'General Group',
    sv: 'Allmän grupp',
    terminolgy: CompanyTerminologyEnum.SUBGR,
  },
  [CompanyAcronymsEnum['SUBGR-STYR']]: {
    nb: 'Styringsgruppe',
    en: 'Steering Comittee',
    sv: 'Styrgrupp',
    terminolgy: CompanyTerminologyEnum.SUBGR,
  },
  [CompanyAcronymsEnum['SUBGR-LEDER']]: {
    nb: 'Ledergruppe',
    en: 'Management Team',
    sv: 'Ledningsgrupp',
    terminolgy: CompanyTerminologyEnum.SUBGR,
  },
  [CompanyAcronymsEnum['SUBGR-VALGKOMITE']]: {
    nb: 'Valgkomite',
    en: 'Nomination Committee',
    sv: 'Valberedning',
    terminolgy: CompanyTerminologyEnum.SUBGR,
  },
  [CompanyAcronymsEnum['SUBGR-RENUM']]: {
    nb: 'Godtgjørelsesutvalg',
    en: 'Remuneration Committee',
    sv: 'Ersättningskommitté',
    terminolgy: CompanyTerminologyEnum.SUBGR,
  },
  [CompanyAcronymsEnum['SUBGR-KONTROL']]: {
    nb: 'Kontrollutvalg',
    en: 'Supervisory Committee',
    sv: 'Kontrollkommitté',
    terminolgy: CompanyTerminologyEnum.SUBGR,
  },
  [CompanyAcronymsEnum['SUBGR-REVISJON']]: {
    nb: 'Revisjonsutvalg',
    en: 'Audit Committee',
    sv: 'Revisionskommitté',
    terminolgy: CompanyTerminologyEnum.SUBGR,
  },
  [CompanyAcronymsEnum['SUBGR-PROJECT']]: {
    nb: 'Prosjektgruppe',
    en: 'Project Group',
    sv: 'Projektgrupp',
    terminolgy: CompanyTerminologyEnum.SUBGR,
  },
  [CompanyAcronymsEnum['SUBGR-COMMITTEE_ENV']]: {
    nb: 'Arbeidsmiljøutvalg',
    en: 'Work Environment Committee',
    sv: 'Arbetsmiljönämnd',
    terminolgy: CompanyTerminologyEnum.SUBGR,
  },
  [CompanyAcronymsEnum['SUBGR-WORKGROUP']]: {
    nb: 'Arbeidsgruppe',
    en: 'Working Group',
    sv: 'Arbetsgrupp',
    terminolgy: CompanyTerminologyEnum.SUBGR,
  },
  [CompanyAcronymsEnum['SUBGR-DD']]: {
    nb: 'Due diligence',
    en: 'Due Diligence',
    sv: 'Due diligence',
    terminolgy: CompanyTerminologyEnum['SUBGR-DD'],
  },
  [CompanyAcronymsEnum['SUBGR']]: {
    nb: 'Legacy subgroup',
    en: 'Legacy Subgroup',
    sv: 'Legacy subgroup',
    terminolgy: CompanyTerminologyEnum.SUBGR,
  },
  [CompanyAcronymsEnum['SPORTS']]: {
    nb: 'Sportsklubb',
    en: 'Sorts club',
    sv: 'Sportsklubb',
    terminolgy: CompanyTerminologyEnum[CompanyTerminologyEnum.fliAlike],
  },
};

for (const key of Object.keys(CompanyAcronymsEnum)) {
  if (!companyAcronymsMap[key].terminolgy) {
    companyAcronymsMap[key].terminolgy = CompanyTerminologyEnum.default;
  }
}
